module.exports = __webpack_public_path__ + "static/media/Human_ZG8447_360.0aec2e25.jpeg";